import { Directive, Input } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

@Directive({
  selector: '[datePickerInputValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: DatePickerInputValidatorDirective,
      multi: true,
    },
  ],
  standalone: false,
})
export class DatePickerInputValidatorDirective implements Validator {
  @Input('datePickerInputValidator') validations?: {
    isWeekendEnabled: boolean;
  };

  validate(control: AbstractControl): ValidationErrors | null {
    //Format validation
    if (
      !this.isValidNgbDateStruct(control.value) ||
      !this.isValidYear(control.value.year)
    ) {
      return { invalidDateFormat: 'invalid date format' };
    }
    //Weekend validation
    if (!this.validations?.isWeekendEnabled && this.isWeekend(control.value)) {
      return { invalidWeekend: 'weekend is disabled' };
    }
    return null;
  }
  isValidYear = (year: number) => year >= 1000 && year <= 9999;

  isValidNgbDateStruct = (date?: NgbDateStruct) =>
    !!(
      date?.hasOwnProperty('year') &&
      date?.hasOwnProperty('month') &&
      date?.hasOwnProperty('day')
    );

  isWeekend(date: NgbDateStruct) {
    const day = moment({
      year: date.year,
      month: date.month - 1,
      day: date.day,
    })
      .toDate()
      .getDay();
    return day == 6 || day == 0; //saturday || sunday
  }
}
